import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'trial-used',
  templateUrl: './trial-used.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
  ]
})
export class TrialUsedComponent implements OnInit {
  @Input() columnData  = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  @Output() onAction = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  OpenTrialHistory(data:any)
  {
      this.onAction.emit({action:'OpenTrialHistory',columnData:data});
  }

}
